var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86523 14C4.49857 14 4.18479 13.8696 3.9239 13.6087C3.66301 13.3478 3.53235 13.0338 3.5319 12.6667V4H2.86523V2.66667H6.19857V2H10.1986V2.66667H13.5319V4H12.8652V12.6667C12.8652 13.0333 12.7348 13.3473 12.4739 13.6087C12.213 13.87 11.899 14.0004 11.5319 14H4.86523ZM11.5319 4H4.86523V12.6667H11.5319V4ZM6.19857 11.3333H7.5319V5.33333H6.19857V11.3333ZM8.86523 11.3333H10.1986V5.33333H8.86523V11.3333Z",
    fill: "#04245C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5306 11.333H6.19727V5.33301H7.5306V11.333Z",
    fill: "#2173FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1973 11.333H8.86393V5.33301H10.1973V11.333Z",
    fill: "#2173FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/delete_outline.59e8344797badb74f57069ce943cc169.svg";
export { ForwardRef as ReactComponent };